var React = require('react');

function IubendaLogo (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M22.1667 10.4451C22.1701 12.9191 21.24 15.312 19.5453 17.1888L21.897 47.2889H0.855694L3.13654 17.7147C1.12591 15.7792 -0.00113778 13.1676 8.61927e-07 10.4465C8.61927e-07 4.67443 4.96091 0 11.0833 0C17.2073 0 22.1667 4.67444 22.1667 10.4451Z","fill":"#1CC691","key":0}),React.createElement("path",{"d":"M10.872 12.9706C12.3158 12.9706 13.4862 11.8498 13.4862 10.4672C13.4862 9.08466 12.3158 7.96387 10.872 7.96387C9.42822 7.96387 8.25781 9.08466 8.25781 10.4672C8.25781 11.8498 9.42822 12.9706 10.872 12.9706Z","fill":"white","key":1}),React.createElement("path",{"d":"M12.9366 21.9316V38.7978H9.35742V25.3552L12.9366 21.9316Z","fill":"white","key":2})]);
}

IubendaLogo.defaultProps = {"width":"23","height":"48","viewBox":"0 0 23 48","fill":"none"};

module.exports = IubendaLogo;

IubendaLogo.default = IubendaLogo;
